const state = {
  memberSearch: {
    dob: '',
    firstName: '',
    lastName: '',
    memberId: '',
    memberStatus: '',
    ssn: '',
  }
}

const getters = {
  memberSearch: (state) => state.memberSearch,
}

const mutations = {
  CLEAR_MEMBER_SEARCH() {
    state.memberSearch = {
      dob: '',
      firstName: '',
      lastName: '',
      memberId: '',
      memberStatus: '',
      ssn: '',
    }
  },
  UPDATE_MEMBER_SEARCH(state, memberSearch) {
    // console.log(`UPDATE_MEMBER_SEARCH`, memberSearch);
    state.memberSearch = memberSearch;
  },
  UPDATE_MEMBER_SEARCH_FIELD(state, opts) {
    // console.log(`UPDATE_MEMBER_SEARCH_FIELD`, opts);
    state.memberSearch[opts.field] = opts.value;
  },
}

export const universalSearch = {
  namespaced: true,
  state,
  getters,
  mutations,
}